﻿package com.mgacreative.hotelru.feature.room.di

import com.mgacreative.hotelru.feature.room.ui.InUseRoomsViewModel
import com.mgacreative.hotelru.feature.room.ui.RoomSummaryViewModel
import org.koin.core.module.dsl.viewModel
import org.koin.dsl.module

fun getRoomFeatureModule() = module {
    // Sadece mevcut olan ViewModel'leri tanımlıyoruz
    viewModel { InUseRoomsViewModel(get(), get(), get(), get(), get(), get()) }
    viewModel { RoomSummaryViewModel(get(), get()) }
}

